<template> 
  <nav class="navbar fixed-bottom navbar-light">
    <span class="navbar-brand kkk mx-auto">RockArt</span>
  </nav>   
</template>

<script>
  export default {
    name: 'custom-footer',
  }
</script>

<style>
  .fixed-bottom{
    padding-top: 1.5%;
    padding-bottom: 1.5%;
    border-top: 1px solid gray;
    background-color: #e9ecef;
  }

  @media (min-width: 768px) {
    .kkk{
      position: absolute;
      width: 100%;
      left: 0;
      text-align: center;
      margin:0 auto;
    }
  }
</style>